// Messages for portal/shipments/ShipmentRow (auto-merged by lib/i18n.ts).
export const en = {
  'portal.shipment_row.complete': '{progress}% complete',
  'portal.shipment_row.more_pos': '{count} more POs',
}

export const zhTW = {
  'portal.shipment_row.complete': '完成 {progress}%',
  'portal.shipment_row.more_pos': '另有 {count} 筆 PO',
}
